export const filters = [
    "price",
    "colors",
    "condition",
    "description",
    "vendors"]